// extracted by mini-css-extract-plugin
export var text = "_59-0";